import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";
import { SortDirection } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { unwrap, orElse, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, AuditLog as AuditLog_1 } from "./ApiClient.jsx";
import { errorToast } from "./Toasts.jsx";
import { DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, SkeletonItem, Skeleton, Subtitle1, ListItem, List, Text as Text$, TableCellLayout, createTableColumn as createTableColumn_4 } from "@fluentui/react-components";
import { compareTo } from "./fable_modules/fable-library-js.4.29.0/Date.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { map as map_1, ofArray, singleton } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { toArray, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.29.0/Range.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";

/**
 * Table displaying audit logs
 */
export function AuditLog(auditLogInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, elems_9;
    const tableName = auditLogInputProps.tableName;
    const patternInput = reactApi.useState(true);
    const setIsFetching = patternInput[1];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState([]);
    const patternInput_3 = reactApi.useState(["datetime", new SortDirection(1, [])]);
    const displayOf = (display, raw) => defaultArg(orElse(display, raw), "");
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise((tableName != null) ? AuditLog_1.GetFromTable(tableName) : AuditLog_1.GetAllAuditLogs());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchAuditLog", "Noe gikk galt", "Kunne ikke hente log", undefined);
                setIsFetching(false);
            }
            else {
                patternInput_2[1](res.fields[0]);
                setIsFetching(false);
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
    });
    const columns = ofArray([(createTableColumn = createTableColumn_4, createTableColumn({
        columnId: "datetime",
        compare: (delegateArg, delegateArg_1) => compareTo(delegateArg.DateTime, delegateArg_1.DateTime),
        renderHeaderCell: () => "",
        renderCell: (delegateArg_3) => {
            let el, locale, formatOptions;
            const log = delegateArg_3;
            const el_2 = TableCellLayout;
            return createElement(el_2, {
                key: `${log.DateTime}`,
                children: singleton((el = Text$, createElement(el, {
                    children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(log.DateTime, "dd MMM yyyy HH:mm:ss", formatOptions))))}`,
                }))),
            });
        },
    })), (createTableColumn_1 = createTableColumn_4, createTableColumn_1({
        columnId: "field",
        renderHeaderCell: () => "Felt",
        renderCell: (delegateArg_5) => {
            let el_8, elems_1;
            const el_10 = TableCellLayout;
            return createElement(el_10, {
                key: "fields",
                children: singleton((el_8 = List, createElement(el_8, createObj(singleton((elems_1 = toList(delay(() => map((change) => {
                    let elems, el_4;
                    const el_6 = ListItem;
                    return createElement(el_6, createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems = [(el_4 = Text$, createElement(el_4, {
                        children: `${change.Field}: `,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                }, delegateArg_5.Changes))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])))))),
            });
        },
    })), (createTableColumn_2 = createTableColumn_4, createTableColumn_2({
        columnId: "old",
        renderHeaderCell: () => "Gammel",
        renderCell: (delegateArg_7) => {
            let el_16, elems_3;
            const el_18 = TableCellLayout;
            return createElement(el_18, {
                key: "old",
                children: singleton((el_16 = List, createElement(el_16, createObj(singleton((elems_3 = toList(delay(() => map((change_1) => {
                    let elems_2, el_12;
                    const el_14 = ListItem;
                    return createElement(el_14, createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems_2 = [(el_12 = Text$, createElement(el_12, {
                        children: displayOf(change_1.OldDisplay, change_1.OldValue),
                        style: {
                            maxWidth: 200,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
                }, delegateArg_7.Changes))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])))))),
            });
        },
    })), (createTableColumn_3 = createTableColumn_4, createTableColumn_3({
        columnId: "new",
        renderHeaderCell: () => "Ny",
        renderCell: (delegateArg_9) => {
            let el_24, elems_5;
            const el_26 = TableCellLayout;
            return createElement(el_26, {
                key: "new",
                children: singleton((el_24 = List, createElement(el_24, createObj(singleton((elems_5 = toList(delay(() => map((change_2) => {
                    let elems_4, el_20;
                    const el_22 = ListItem;
                    return createElement(el_22, createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems_4 = [(el_20 = Text$, createElement(el_20, {
                        children: displayOf(change_2.NewDisplay, change_2.NewValue),
                        style: {
                            maxWidth: 200,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
                }, delegateArg_9.Changes))), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])))))),
            });
        },
    }))]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_9 = toList(delay(() => {
        let el_28;
        return append(singleton_1((el_28 = Subtitle1, createElement(el_28, {
            children: "Endringslogg",
        }))), delay(() => {
            let el_32, elems_6, el_42, tupledArg, elems_8, props_53, el_34, name_3, el_40;
            return patternInput[0] ? singleton_1((el_32 = Skeleton, createElement(el_32, createObj(ofArray([["height", 150], ["style", {
                display: "flex",
                flexDirection: "column",
                gap: 2 + "px ",
            }], (elems_6 = toList(delay(() => map_1((_arg_5) => {
                const el_30 = SkeletonItem;
                return createElement(el_30, {
                    size: 24,
                });
            }, toList(rangeDouble(1, 1, 10))))), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))) : singleton_1((el_42 = DataGrid, createElement(el_42, createObj(ofArray([["size", "small"], dataGrid_items_Z6D8BD2B8(patternInput_2[0].filter((log_4) => (log_4.Action === 3))), ["columns", toArray(columns)], ["sortable", true], (tupledArg = patternInput_3[0], ["sortState", {
                sortColumn: unwrap(tupledArg[0]),
                sortDirection: tupledArg[1],
            }]), ["onSortChange", (delegateArg_10, delegateArg_1_1) => {
                const sortState_1 = delegateArg_1_1;
                patternInput_3[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
            }], ["resizableColumnsOptions", {
                autoFitColumns: true,
            }], (elems_8 = [(props_53 = singleton((el_34 = DataGridRow, createElement(el_34, {
                appearance: "brand",
                children: (delegateArg_11, delegateArg_1_2) => {
                    const props_48 = singleton(delegateArg_11.renderHeaderCell());
                    const name_1 = DataGridHeaderCell;
                    return createElement(name_1, {
                        children: reactApi.Children.toArray(Array.from(props_48)),
                    });
                },
            }))), (name_3 = DataGridHeader, createElement(name_3, {
                children: reactApi.Children.toArray(Array.from(props_53)),
            }))), (el_40 = DataGridBody, createElement(el_40, {
                children: (delegateArg_13) => {
                    const trd = delegateArg_13;
                    const el_38 = DataGridRow;
                    return createElement(el_38, {
                        key: trd.rowId,
                        children: (delegateArg_12, delegateArg_1_3) => {
                            let elems_7;
                            const tcd_1 = delegateArg_12;
                            const el_36 = DataGridCell;
                            return createElement(el_36, createObj(ofArray([["key", tcd_1.columnId], (elems_7 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
                        },
                    });
                },
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

//# sourceMappingURL=AuditTable.jsx.map
